// extracted by mini-css-extract-plugin
export default {"networkStatus":"NetworkStatus_networkStatus__e5JX+"};